export namespace StartAndEndDate {
	export namespace Type {
		export type DateObject = Base<Date>;
		export type DateOrString = Base<Date | string>;
		export type String = Base<string>;
	}

	type Base<T extends any> = {
		startDate: T;
		endDate: T;
	};
}
